const getVehiclePayload = (vehicle) => {
	return {
			bodyStyle: vehicle.bodyStyle,
			condition: vehicle.inventoryType,
			listingType: vehicle.priorityType,
			make: vehicle.make,
			model: vehicle.model,
			price: vehicle.finalPrice,
			stockNumber: vehicle.stockNumber,
			title: [`${vehicle.year} ${vehicle.make}`, `${vehicle.model} ${vehicle.trim}`],
			trim: vehicle.trim,
			type: vehicle.inventoryType,
			uuid: vehicle.uuid,
			vin: vehicle.vin,
			year: vehicle.year
	}
};

export const trackEvent = (interactionData) => {
	if (window.DDC && window.DDC.fireTrackingEvent) {
		const defaultData = {
			event: 'thirdPartyUserEvent',
			product: 'My Wallet Syndication',
			step: 'Any My Wallet Step',
			noninteraction: false
		};

		const {
			vehicle,
			...restOfInteractionData
		} = interactionData;

		window.DDC.fireTrackingEvent({
			...defaultData,
			...restOfInteractionData,
			...(vehicle && {vehicle: getVehiclePayload(vehicle)})
		});
	}
}

const destructureEventName = (eventNameFromAccelerate) => {
	const eventNameArray = eventNameFromAccelerate.toLowerCase().split('_').slice(1);
	return {
		action: eventNameArray.pop(),
		element: eventNameArray.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(' ') || undefined
	}
};

export const trackWidgetUserEvent = ({
	element, action, data, eventName, vehicle
}) => {
	if (typeof jQuery !== 'undefined') {
		jQuery(document).trigger('trackEvent', {
			event: 'widgetUserEvent',
			widgetName: 'digital-retailing-cox',
			widgetId: 'digital-retailing1',
			element,
			action,
			elementCTA: undefined,
			result: undefined,
			widgetState: data?.dealType,
			fieldValue: undefined,
			formId: undefined,
			formEventId: undefined,
			value: undefined,
			sourceData: data,
			eventName,
			...(vehicle && {vehicle: getVehiclePayload(vehicle)})
		});
	}
};

const trackTraditionalEvent = (element, action) => {
	if (typeof jQuery !== 'undefined') {
		jQuery(document).trigger('trackEvent', {
			widgetName: 'mywallet-integration',
			eventName: action,
			data: element
		});
	}
};

export const trackCADREvent = (eventName, eventData) => {
	const { action, element } = destructureEventName(eventName);

	trackWidgetUserEvent({element, action, data: eventData, eventName});
	trackTraditionalEvent(element, action);

	return true;
};
